import React from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import asyncComponent from "../../helpers/AsyncFunc";

const routes = [
  {
    path: "",
    permissions: ["Login"],
    component: asyncComponent(() => import("../Dashboard/Dashboard")),
  },
  {
    path: "users",
    permissions: ["Login", "UserEditor"],
    component: asyncComponent(() => import("../Users/Users")),
  },
  {
    path: "usergroups",
    permissions: ["Login", "UserGroupsEditor"],
    component: asyncComponent(() => import("../UserGroups/UserGroups")),
  },
  {
    path: "locations",
    permissions: ["Login", "LocationsEditor"],
    component: asyncComponent(() => import("../Locations/Locations")),
  },
  {
    path: "access",
    permissions: ["Login", "AccessLevelsEditor"],
    component: asyncComponent(() => import("../Access/Access")),
  },
  {
    path: "authcheck",
    permissions: ["Login"],
    component: asyncComponent(() => import("../Authcheck/Authcheck")),
  },
  {
    path: "log",
    permissions: ["Login", "LogViewer"],
    component: asyncComponent(() => import("../Log/Log")),
  },

  // Development route for creating a new page, this is to be commented in and out as needed.
  {
    path: "development",
    permissions: ["Login"],
    component: asyncComponent(() => import("../Development/Index")),
  },
];

function AppRouter(props) {
  const permissionCheck = (permissions) => {
    let hasPermission = (arr, target) => target.every((v) => arr.includes(v));
    return hasPermission(props.user.PortalPermissions, permissions);
  };
  const { style } = props;
  return (
    <div style={style}>
      {routes.map((route) => {
        const { path, exact, ...other } = route;
        if (permissionCheck(route.permissions)) {
          return (
            <Route
              exact={exact === false ? false : true}
              key={route.path}
              path={`/${route.path}`}
              {...other}
            />
          );
        }
      })}
    </div>
  );
}

export default connect(
  (state) => ({
    user: state.Auth.user,
  }),
  {}
)(AppRouter);
